// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --bgColor: rgb(243 248 243);
  --boxTitleBg: rgb(222 235 222);
  --borderColor: rgb(54 128 53);
}

body {
  font-family: sans-serif;
  font-size: 16px;
  color: #333;
  background: var(--bgColor);
  max-height: 100vh;
  overflow: hidden;
}

.container {
  width: 100%;
  margin: auto;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 20px;
  padding: 20px;
  height: 100%;
  max-height: 100vh;
  overflow: hidden;
}

.left-bar-container {
  padding: 10px;
  background: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.left-bar-container .menu {
  height: 30px;
  min-height: 30px;
  padding: 10px;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  transition: .3s ease-in-out;
}

.left-bar-container .menu * {
  -webkit-user-select: none;
  user-select: none;
}

.left-bar-container .menu .menu-icon {
  transition: .3s ease-in-out;
}

.left-bar-container .menu.active .menu-icon {
  transform: translateY(-50%) rotate(-180deg) !important
}

.left-bar-container .menu .sub-menu {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  border-left: 2px solid var(--borderColor);
}

.left-bar-container .menu .sub-menu span {
  padding: 5px 10px;
  cursor: pointer;
}

.left-bar-container .menu .menu-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  -webkit-tap-highlight-color: transparent;
}

.left-bar-container .menu .menu-inner * {
  pointer-events: none;
}

.left-bar-container .menu .menu-name {
  font-weight: 600;
  width: max-content;
  max-width: 95%;
  clear: both;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.left-bar-container .menu .menu-inner .menu-icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.boxes-container-outer {
  height: 100%;
  max-height: inherit;
  overflow: hidden;
  overflow-y: auto;
}

.boxes-container {
  display: flex;
  flex-direction: column;
  gap: 50px;
  height: max-content;
  padding-bottom: 150px;
}

.boxes-container .section {
  display: flex;
  flex-direction: column;
  gap: 10px
}

.box-container {
  border: 1px solid var(--borderColor);
  border-radius: 20px;
  background: white;
  overflow: hidden;
}

.box-container .heading {
  padding: 15px;
  border-bottom: 1px solid var(--borderColor);
  background: var(--boxTitleBg);
  font-weight: 600;
}

.box-container .body {
  padding: 15px;
  position: relative;
}

.box-container .last-box-content {
  position: absolute;
  left: 72px;
  top: 37px;
  display: flex;
  flex-direction: column;
  gap: 33px;
}

.box-container .body div {
  padding-left: 10px;
}

.box-container .body p {
  margin-bottom: 5px;
}

.box-container .body .paragraph {
  padding-left: 15px;
  margin-bottom: 15px;
}

.box-container .body .paragraph.df {
  display: flex;
  gap: 5px;
}

.box-container .body ul {
  padding-left: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  line-height: 1.3;
}

.box-container .body ul .first-li {
  display: flex;
  gap: 5px;
  margin-bottom: 8px;
}

.box-container .body ul:last-child .first-li {
  margin-bottom: 0;
}

.box-container .body ul li ul li {
  margin-bottom: 8px;
  display: flex;
  gap: 5px;
}

.box-container .body img {
  max-width: 100%;
  object-fit: contain;
}

.top-menu-bar,
.menu-bg,
.left-menu-bar-top .menu-close {
  display: none;
}

.left-menu-bar-top .menu-close {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.left-menu-bar-top .menu-close * {
  pointer-events: none;
}

.top-menu-bar {
  padding: 0 20px;
}

.top-menu-bar button {
  background: none;
  width: 35px;
  height: 35px;
  border: none;
  cursor: pointer;
}

.top-menu-bar button * {
  pointer-events: none;
}

/* ---------------- responsive ---------------- */
@media only screen and (max-width: 768px) {
  .left-bar-container {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: max-content;
    overflow: hidden;
    overflow-y: auto;
    background: white;
    transition: .3s ease-in-out;
    z-index: 9;
    border-radius: 0;
    max-width: 100%;
    transform: translateX(-100%);
    padding-bottom: 100px;
  }

  .container {
    gap: 0;
    grid-template-columns: 1fr;
    padding: 0;
  }

  .boxes-container-outer {
    padding: 0 20px;
  }

  .top-menu-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    width: 100%;
    top: 0;
    left: 0;
    background: white;
    height: 40px;
    z-index: 1;
  }

  .menu-bg,
  .left-menu-bar-top .menu-close {
    display: block;
  }

  .left-menu-bar-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    padding: 0 15px;
  }

  .left-bar-container~.menu-bg {
    content: "";
    width: 100vw;
    height: 100vh;
    display: block;
    background: #3333;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    opacity: 0;
    visibility: hidden;
    transition: .3s ease-in-out;
  }

  .left-bar-container.active {
    transform: translateX(0);
  }

  .left-bar-container.active~.menu-bg {
    opacity: 1;
    visibility: visible;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EAEV,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EAEZ,aAAa;EAEb,+BAA+B;EAC/B,SAAS;EACT,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EAGnB,aAAa;EAIb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EAGzB,iBAAiB;EAGjB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;EAGE;AACF;;AAEA;EACE,eAAe;EAGf,aAAa;EAIb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAGhB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EAEnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EAGR,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EACtB,SAAS;EAGT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EACtB;AACF;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EAGT,aAAa;EAIb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAGE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EAIb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EAEf,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iDAAiD;AACjD;EACE;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IAGb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IAGjB,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;IAChB,eAAe;IAGf,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE,MAAM;IAEN,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IAGE,aAAa;IAGb,mBAAmB;IAGnB,8BAA8B;IAC9B,gBAAgB;IAChB,WAAW;IACX,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,YAAY;IACZ,UAAU;EACZ;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IAGE,aAAa;IAGb,mBAAmB;IAGnB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;IACV,UAAU;IACV,kBAAkB;IAGlB,2BAA2B;EAC7B;;EAEA;IAGE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n:root {\n  --bgColor: rgb(243 248 243);\n  --boxTitleBg: rgb(222 235 222);\n  --borderColor: rgb(54 128 53);\n}\n\nbody {\n  font-family: sans-serif;\n  font-size: 16px;\n  color: #333;\n  background: var(--bgColor);\n  max-height: 100vh;\n  overflow: hidden;\n}\n\n.container {\n  width: 100%;\n  margin: auto;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: auto 20px 1fr;\n  grid-template-columns: auto 1fr;\n  gap: 20px;\n  padding: 20px;\n  height: 100%;\n  max-height: 100vh;\n  overflow: hidden;\n}\n\n.left-bar-container {\n  padding: 10px;\n  background: white;\n  border-radius: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.left-bar-container .menu {\n  height: 30px;\n  min-height: 30px;\n  padding: 10px;\n  overflow: hidden;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -webkit-transition: .3s ease-in-out;\n  -o-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.left-bar-container .menu * {\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n\n.left-bar-container .menu .menu-icon {\n  -webkit-transition: .3s ease-in-out;\n  -o-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.left-bar-container .menu.active .menu-icon {\n  -webkit-transform: translateY(-50%) rotate(-180deg) !important;\n  -ms-transform: translateY(-50%) rotate(-180deg) !important;\n  transform: translateY(-50%) rotate(-180deg) !important\n}\n\n.left-bar-container .menu .sub-menu {\n  margin-top: 5px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-left: 2px solid var(--borderColor);\n}\n\n.left-bar-container .menu .sub-menu span {\n  padding: 5px 10px;\n  cursor: pointer;\n}\n\n.left-bar-container .menu .menu-inner {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  cursor: pointer;\n  position: relative;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.left-bar-container .menu .menu-inner * {\n  pointer-events: none;\n}\n\n.left-bar-container .menu .menu-name {\n  font-weight: 600;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  max-width: 95%;\n  clear: both;\n  display: inline-block;\n  overflow: hidden;\n  white-space: nowrap;\n  -o-text-overflow: ellipsis;\n  text-overflow: ellipsis;\n}\n\n.left-bar-container .menu .menu-inner .menu-icon {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.boxes-container-outer {\n  height: 100%;\n  max-height: inherit;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.boxes-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  gap: 50px;\n  height: -webkit-max-content;\n  height: -moz-max-content;\n  height: max-content;\n  padding-bottom: 150px;\n}\n\n.boxes-container .section {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  gap: 10px\n}\n\n.box-container {\n  border: 1px solid var(--borderColor);\n  border-radius: 20px;\n  background: white;\n  overflow: hidden;\n}\n\n.box-container .heading {\n  padding: 15px;\n  border-bottom: 1px solid var(--borderColor);\n  background: var(--boxTitleBg);\n  font-weight: 600;\n}\n\n.box-container .body {\n  padding: 15px;\n  position: relative;\n}\n\n.box-container .last-box-content {\n  position: absolute;\n  left: 72px;\n  top: 37px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  gap: 33px;\n}\n\n.box-container .body div {\n  padding-left: 10px;\n}\n\n.box-container .body p {\n  margin-bottom: 5px;\n}\n\n.box-container .body .paragraph {\n  padding-left: 15px;\n  margin-bottom: 15px;\n}\n\n.box-container .body .paragraph.df {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 5px;\n}\n\n.box-container .body ul {\n  padding-left: 15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  gap: 8px;\n  list-style: none;\n  line-height: 1.3;\n}\n\n.box-container .body ul .first-li {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 5px;\n  margin-bottom: 8px;\n}\n\n.box-container .body ul:last-child .first-li {\n  margin-bottom: 0;\n}\n\n.box-container .body ul li ul li {\n  margin-bottom: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 5px;\n}\n\n.box-container .body img {\n  max-width: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n\n.top-menu-bar,\n.menu-bg,\n.left-menu-bar-top .menu-close {\n  display: none;\n}\n\n.left-menu-bar-top .menu-close {\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.left-menu-bar-top .menu-close * {\n  pointer-events: none;\n}\n\n.top-menu-bar {\n  padding: 0 20px;\n}\n\n.top-menu-bar button {\n  background: none;\n  width: 35px;\n  height: 35px;\n  border: none;\n  cursor: pointer;\n}\n\n.top-menu-bar button * {\n  pointer-events: none;\n}\n\n/* ---------------- responsive ---------------- */\n@media only screen and (max-width: 768px) {\n  .left-bar-container {\n    position: fixed;\n    left: 0;\n    top: 0;\n    height: 100vh;\n    width: -webkit-max-content;\n    width: -moz-max-content;\n    width: max-content;\n    overflow: hidden;\n    overflow-y: auto;\n    background: white;\n    -webkit-transition: .3s ease-in-out;\n    -o-transition: .3s ease-in-out;\n    transition: .3s ease-in-out;\n    z-index: 9;\n    border-radius: 0;\n    max-width: 100%;\n    -webkit-transform: translateX(-100%);\n    -ms-transform: translateX(-100%);\n    transform: translateX(-100%);\n    padding-bottom: 100px;\n  }\n\n  .container {\n    gap: 0;\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    padding: 0;\n  }\n\n  .boxes-container-outer {\n    padding: 0 20px;\n  }\n\n  .top-menu-bar {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    position: sticky;\n    width: 100%;\n    top: 0;\n    left: 0;\n    background: white;\n    height: 40px;\n    z-index: 1;\n  }\n\n  .menu-bg,\n  .left-menu-bar-top .menu-close {\n    display: block;\n  }\n\n  .left-menu-bar-top {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    height: 50px;\n    padding: 0 15px;\n  }\n\n  .left-bar-container~.menu-bg {\n    content: \"\";\n    width: 100vw;\n    height: 100vh;\n    display: block;\n    background: #3333;\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 0;\n    opacity: 0;\n    visibility: hidden;\n    -webkit-transition: .3s ease-in-out;\n    -o-transition: .3s ease-in-out;\n    transition: .3s ease-in-out;\n  }\n\n  .left-bar-container.active {\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  .left-bar-container.active~.menu-bg {\n    opacity: 1;\n    visibility: visible;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
